// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"421":"7566a6ad","2000":"e8867c6f"}[chunkId] || chunkId) + "." + {"161":"eb0b9cf8d5e1e16a","421":"4c260732ba74706f","2000":"88da21e6af02c5d7","5091":"26753aff029a2b9b"}[chunkId] + ".js";
};